//////LIBRARY//////
import React, { useEffect, useState, useMemo } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, isEqual, find, map, filter, isNull, forEach } from 'lodash'
//////COMPONENTS//////
import theme from '../../theme/theme'
import Table from '../../components/Table'
import { initKioskCreationImplantationActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import { uriList } from '../../routings/settings/RouteList'
import userPrivileges from '../../constants/PrivilegesList'
import StringFormatter from '../../../src/helpers/StringFormatter'
import Button from '../../components/Ui/Buttons'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { KioskImplantationImg, KioskImplantationStatus } from './Components'
import UseCheckAll from '../../hooks/UseCheckAll'
import Modals from '../../components/Modals'
import { PageWrapperLinks, TextModal, LabelText, SelectInputWrapper, SelectInput } from '../../theme/GlobalCss'
import TableTitle from '../../components/Table/components/TableTitle'
import TooltipHelp from '../../components/TooltipHelp'
//////ASSETS//////
import ArrowWhiteRight from '../../assets/icones/global/arrow-white-right.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import deleteHomeLocker from '../../assets/icones/implantation/deleteHomeLocker.svg'
import unlocateItem from '../../assets/icones/implantation/unlocateItem.svg'
import unlocateLocker from '../../assets/icones/implantation/unlocateLocker.svg'
import alocateItem from '../../assets/icones/implantation/alocateItem.svg'
import alocateLocker from '../../assets/icones/implantation/alocateLocker.svg'
import declareHomeLocker from '../../assets/icones/implantation/declareHomeLocker.svg'

//////STYLED//////
const KioskAddItemWrapper = styled.div`
	position: relative;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	justify-content: space-around;
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
const TextModalWrapperBottom = styled(TextModalWrapper)`
	margin-bottom: 15px;
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	height: auto;
`
const ModalSelectWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: ${(props) => (props.direction ? props.direction : 'row')};
	margin-bottom: 15px;
`
const LabelTextCustom = styled(LabelText)`
	margin-right: 20px;
	display: flex;
	align-items: center;
`
const WrapperElements = styled.div`
	max-height: 150px;
	overflow-y: auto;
	width: 100%;
`
const Elements = styled.div`
	height: auto;
	display: flex;
	justify-content: center;
	color: ${theme.colors.primary};
`
//////STYLED//////

const KioskImplantation = () => {
	const {
		user,
		userRolePrivileges,
		translations,
		initKioskCreationStatus,
		initKioskCreationContent,
		initKioskCreation,
		initKioskCreationIsUpdate,
		initKioskCreationItems,
		initKioskCreationFilters,
		initKioskCreationItemsBrands,
		initKioskCreationItemsCatalog,
		idDisplayStandImplantation,
		idDisplayStandImplantationMassActions,
		idDisplayStandImplantationNextStepError,
		idDisplayStandImplantationNextStepErrorMessage,
		isSearchfieldUpdated,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			userRolePrivileges: state.user.identity.rolePrivileges,
			initKioskCreationFilters: state.initKioskCreation?.initKioskImplantation?.data?.headerParam?.filters,
			initKioskCreationItems: state.initKioskCreation.initKioskImplantation,
			initKioskCreation: state.initKioskCreation,
			initKioskCreationContent: state.initKioskCreation?.initKioskImplantation?.data?.headerContent?.contentPagined?.content,
			initKioskCreationStatus: state.initKioskCreation?.initKioskImplantation?.data?.headerParam?.progressInfo,
			initKioskCreationIsUpdate: state.initKioskCreation?.initKioskImplantation?.isUpdate,
			initKioskCreationItemsBrands: state.initKioskCreation.initKioskImplantation.catalog.brands,
			initKioskCreationItemsCatalog: state.initKioskCreation.initKioskImplantation.catalog.itemsCatalog,
			idDisplayStandImplantation: state.initKioskCreation?.initKioskImplantation?.data?.headerParam?.idDisplayStandImplantation,
			idDisplayStandImplantationMassActions: state.initKioskCreation?.initKioskImplantation?.data?.headerParam?.massActions,
			idDisplayStandImplantationNextStepError: state.initKioskCreation?.error?.data?.errorCode,
			idDisplayStandImplantationNextStepErrorMessage: state.initKioskCreation?.error?.data?.traductionKey,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
		}),
		shallowEqual
	)
	const actionsImplantation = bindActionCreators(initKioskCreationImplantationActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const location = useLocation()
	let history = useHistory()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	const [isEditable, setIsEditable] = useState(false)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '50' })
	const [row, setRow] = useState({})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modal
	// Action unitaire
	const [showModalActivation, setShowModalActivation] = useState(false)
	const [showModalActivationEdit, setShowModalActivationEdit] = useState(false)
	const [showModalUnlocateLocker, setShowModaUnlocateLocker] = useState(false)
	const [showModalDeclareHomeLockerBrand, setShowModalDeclareHomeLockerBrand] = useState(false)
	const [showModalDeclareHomeLockerItem, setShowModalDeclareHomeLockerItem] = useState(false)
	const [showModalDeleteHomeLocker, setShowModalDeleteHomeLocker] = useState(false)
	const [showModalDesactivateLocker, setShowModalDesactivateLocker] = useState(false)
	const [showModalDesactivateAllocatedLocker, setShowModalDesactivateAllocatedLocker] = useState(false)

	// Actions globales
	const [showModalActions, setShowModalActions] = useState(false) // VOIR SI PLURIEL OU SI 1 SEUL MODAL?
	const [showModalAllocatedLockerImpossible, setShowModalAllocatedLockerImpossible] = useState(false)
	const [showModalActivationsEdit, setShowModalActivationsEdit] = useState(false)
	const [showModalUnlocateLockers, setShowModalUnlockateLockers] = useState(false)
	const [showModalDeleteHomeLockers, setShowModalDeleteHomeLockers] = useState(false)
	const [showModalDesactivateLockers, setShowModalDesactivateLockers] = useState(false)
	const [showModalDesactivateAllocatedLockers, setShowModalDesactivateAllocatedLockers] = useState(false)

	const [validationImpossible, setValidationImpossible] = useState(false)

	// Filter Modal
	const [catalogItems, setCatalogItems] = useState()

	const match = useRouteMatch()

	// Id catalog
	const [itemDistributorId, setItemDistributorId] = useState()
	const [itemBrandId, setItemBrandId] = useState()

	const [currentCaseId, setCurrentCaseId] = useState()
	const [currentItemBrand, setCurrentItemBrand] = useState()
	const [currentItem, setCurrentItem] = useState()

	const [currentItemEdit, setCurrentItemEdit] = useState()
	const [currentBrandEdit, setCurrentBrandEdit] = useState()

	const [massActionsSelected, setMassActionSelected] = useState()

	const [massDatas, setMassDatas] = useState()

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER //////////////////////////////////////

	////////////////////////////HANDLER MODAL ////////////////////////////////////////
	const handleModalDeclareHomeLockerBrand = () => {
		setShowModalDeclareHomeLockerBrand(true)
	}

	const handlesetModalDeclareHomeLockerItem = () => {
		setShowModalDeclareHomeLockerItem(true)
	}

	const handleCloseModal = () => {
		if (showModalActivation) {
			setShowModalActivation(false)
		} else if (showModalActivationEdit) {
			setShowModalActivationEdit(false)
		} else if (showModalUnlocateLocker) {
			setShowModaUnlocateLocker(false)
		} else if (showModalDeclareHomeLockerBrand) {
			setShowModalDeclareHomeLockerBrand(false)
		} else if (showModalDeclareHomeLockerItem) {
			setShowModalDeclareHomeLockerItem(false)
		} else if (showModalDeleteHomeLocker) {
			setShowModalDeleteHomeLocker(false)
		} else if (showModalDesactivateLocker) {
			setShowModalDesactivateLocker(false)
		} else if (showModalDesactivateAllocatedLocker) {
			setShowModalDesactivateAllocatedLocker(false)
		} else if (showModalAllocatedLockerImpossible) {
			setShowModalAllocatedLockerImpossible(false)
		} else if (showModalActivationsEdit) {
			setShowModalActivationsEdit(false)
		} else if (showModalUnlocateLockers) {
			setShowModalUnlockateLockers(false)
		} else if (showModalDeleteHomeLockers) {
			setShowModalDeleteHomeLockers(false)
		} else if (showModalDesactivateLockers) {
			setShowModalDesactivateLockers(false)
		} else if (showModalDesactivateAllocatedLockers) {
			setShowModalDesactivateAllocatedLockers(false)
		} else if (showModalActions) {
			setShowModalActions(false)
		} else if (validationImpossible) {
			setValidationImpossible(false)
			actionsImplantation.resetErrorImplantation(false)
		}
	}
	/////////////////////////// HANDLER MASS ACTIONS/////////////////

	const handleGetSelectedRow = (data, query) => {
		setMassDatas(data)
		handleSwitchActions(query, data)
	}

	const handleSwitchActions = (query, data) => {
		// value can be found in target or directly accessible in query object
		let queryValue
		if (!isUndefined(query?.target?.value)) {
			queryValue = query?.target?.value
		} else {
			queryValue = query?.value
		}
		setMassActionSelected(queryValue)

		switch (queryValue) {
			case 'ToAllocateItems':
				setShowModalActions(true)
				setItemDistributorId([])
				actionsImplantation.getItemsCatalogGrowth(match.params.id, 'items-catalog')
				break
			case 'ToUnllocateItems':
				handleSetUnllocateItems(data)
				break
			case 'ToDeleteHomeLockers':
				handleSetDelete(data)
				break
			case 'ToActivateLockers':
				handleActivateLockers(data)
				break
			case 'ToDeactivateLockers':
				handleSetDesactivateLockers(data)
				break
			default:
				break
		}
	}

	////////////////////////// HANDLER UNIT ACTION///////////////////
	const handleItemAssign = (row) => {
		setShowModalActivation(true)
		setRow(row)
		setCurrentItemBrand(isNull(row.itemBrand) ? '' : row.itemBrand.label)
		setCurrentItem(isNull(row.itemLabelToDisplay) ? '' : row.itemLabelToDisplay)
		setCurrentCaseId(isNull(row.lockerLabel) ? '' : row.lockerLabel)
		setItemDistributorId([])
		actionsImplantation.getItemsCatalogGrowth(match.params.id, 'items-catalog')
	}

	const handleDeclareHomeLocker = (row) => {
		setRow(row)

		actionsImplantation.getItemsCatalogGrowth(match.params.id, 'items-homelocker')
		const caseList = [row.id]
		const requestId = match.params.id
		const query = 'ToDeclareHomeLocker'
		const toast = 'toast__initKiosk__kioskCreation_growth__homeLockerDeclared'
		if (idDisplayStandImplantation === 1) {
			actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		} else if (idDisplayStandImplantation === 2) {
			handleModalDeclareHomeLockerBrand()
			setCurrentCaseId(row.lockerLabel)
		} else if (idDisplayStandImplantation === 3) {
			handlesetModalDeclareHomeLockerItem()
			setCurrentCaseId(row.lockerLabel)
		}
	}

	const handleUnlocateItem = (row) => {
		setRow(row)
		setShowModaUnlocateLocker(true)
		setCurrentCaseId(row.lockerLabel)
		setCurrentItemBrand(row.itemBrand.label)
		setCurrentItem(row.itemLabelToDisplay)
	}

	const handleSetDeleteHomeLocker = (row) => {
		setRow(row)
		setShowModalDeleteHomeLocker(true)
		setCurrentCaseId(row.lockerLabel)
	}

	const handleSetDesactivateLocker = (row) => {
		setRow(row)
		setCurrentCaseId(row.lockerLabel)
		setCurrentItemBrand(isNull(row.itemBrand) ? '' : row.itemBrand.label)
		setCurrentItem(row.itemLabelToDisplay)
		if (!row.isAllocated) {
			setShowModalDesactivateLocker(true)
		} else if (row.isAllocated || row.isHomeLocker) {
			setShowModalDesactivateAllocatedLocker(true)
		}
	}

	/////////////// HANDLER MASS ACTIONS ///////////////

	const handleSetDesactivateLockers = (massDatas) => {
		let isAllocated = false
		let isHomeLocker = false

		forEach(massDatas, (elem) => {
			if (elem.isAllocated && !isAllocated) {
				isAllocated = true
			}

			if (elem.isHomeLocker && !isHomeLocker) {
				isHomeLocker = true
			}
		})

		if (!isAllocated) {
			setShowModalDesactivateLockers(true)
		} else if (isAllocated || isHomeLocker) {
			setShowModalDesactivateAllocatedLockers(true)
		}
	}

	const handleSetDelete = (massDatas) => {
		let isHomeLocker = false
		const toast = 'toast__initKiosk__kioskCreation_growth__homeLockersDeleted'
		const caseList = map(massDatas, (e) => e.id)
		const query = 'ToDeleteHomeLockers'
		const requestId = match.params.id

		forEach(massDatas, (elem) => {
			if (elem.isHomeLocker && !isHomeLocker) {
				isHomeLocker = true
			}
		})

		if (!isHomeLocker) {
			actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
			handleCloseModal()
		} else if (isHomeLocker) {
			setShowModalDeleteHomeLockers(true)
		}
	}

	const handleSetUnllocateItems = (massDatas) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__itemsUnllocate'
		const caseList = map(massDatas, (e) => e.id)
		const query = 'ToUnllocateItems'
		const requestId = match.params.id

		let isAllocated = false

		forEach(massDatas, (elem) => {
			if (elem.isAllocated && !isAllocated) {
				isAllocated = true
			}
		})
		if (isAllocated) {
			setShowModalUnlockateLockers(true)
		} else if (!isAllocated) {
			actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
			handleCloseModal()
		}
	}
	///////////// HANDLER CATALOG ITEMS///////// ////////
	const handleFilterBrands = (e) => {
		let brandId = ''
		if (e.target.value !== '0') {
			brandId = filter(initKioskCreationItemsBrands, (elem) => {
				if (elem.id === parseInt(e.target.value)) {
					return elem.id
				}
			})
		}
		if (e.target.value === '0') {
			brandId = initKioskCreationItemsBrands
		}
		if (brandId.length === 1) {
			setCatalogItems(
				filter(initKioskCreationItemsCatalog, (elem) => {
					if (elem.idItemBrand === brandId[0].id) {
						return elem
					}
				})
			)
		} else if (brandId.length > 1) {
			setCatalogItems(initKioskCreationItemsCatalog)
		}

		for (const p in initKioskCreationItemsBrands) {
			if (initKioskCreationItemsBrands[p].id === parseInt(e.target.value)) {
				setCurrentBrandEdit(!isUndefined(initKioskCreationItemsBrands[p].label) ? initKioskCreationItemsBrands[p].label : '')
				//currentBrandEdit
			}
		}
	}

	const handleGetItemDistributorId = (e) => {
		setItemDistributorId(
			filter(initKioskCreationItemsCatalog, (elem) => {
				if (elem.id === parseInt(e.target.value)) {
					return elem.id
				}
			})
		)

		for (const p in initKioskCreationItemsCatalog) {
			if (initKioskCreationItemsCatalog[p].id === parseInt(e.target.value)) {
				setCurrentItemEdit(initKioskCreationItemsCatalog[p].label)
				//currentBrandEdit
			}
		}
	}

	const handleGetItemBrandId = (e) => {
		setItemBrandId(
			filter(initKioskCreationItemsBrands, (elem) => {
				if (elem.id === parseInt(e.target.value)) {
					return elem.id
				}
			})
		)
	}

	//////////////////////// HANDLER BUTTON VALIDATION UNIT ACTION ///////////////////////////////////
	const handleAllocateItem = (row) => {
		const caseList = [row.id]
		const requestId = match.params.id
		const idDistributor = map(itemDistributorId, (e) => e.id)[0]
		const arg = `&itemDistributorId=${idDistributor}`
		const query = 'ToAllocateItem'
		const toast = 'toast__initKiosk__kioskCreation_growth__assignedProduct'
		if (!row.isAllocated) {
			actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query, arg)
			handleCloseModal()
			setItemDistributorId([])
		} else if (row.isAllocated) {
			handleCloseModal()
			setShowModalActivationEdit(true)
		}
	}
	const handleAssignationEdit = (row) => {
		const caseList = [row.id]
		const requestId = match.params.id
		const idDistributor = map(itemDistributorId, (e) => e.id)[0]
		const arg = `&itemDistributorId=${idDistributor}`
		const query = 'ToAllocateItem'
		const toast = 'toast__initKiosk__kioskCreation_growth__assignedProduct'
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query, arg)
		handleCloseModal()
	}

	const handleDeclareHomeLockerBrand = (row) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__homeLockerDeclared'
		const caseList = [row.id]
		const query = 'ToDeclareHomeLocker'
		const requestId = match.params.id
		const idBrand = map(itemBrandId, (e) => e.id)[0]
		const arg = `&itemBrandId=${idBrand}`
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query, arg)
		setItemBrandId([])
		handleCloseModal()
	}

	const handleDeclareHomeLockerItem = (row) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__homeLockerDeclared'
		const caseList = [row.id]
		const query = 'ToDeclareHomeLocker'
		const requestId = match.params.id
		const idDistributor = map(itemDistributorId, (e) => e.id)[0]
		const arg = `&itemDistributorId=${idDistributor}`
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query, arg)
		setItemDistributorId([])
		handleCloseModal()
	}

	const handleUnlocateLocker = (row) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__itemUnllocate'
		const caseList = [row.id]
		const query = 'ToUnllocateItem'
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}

	const handleDeleteHomeLocker = (row) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__homeLockerDeleted'
		const caseList = [row.id]
		const query = 'ToDeleteHomeLocker'
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}

	const handleActivateLocker = (row) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__lockerActivate'
		const caseList = [row.id]
		const query = 'ToActivateLockers'
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}

	const handleDesactivateLocker = (row) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__lockerDeactivated'
		const caseList = [row.id]
		const query = 'ToDeactivateLocker'
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}
	///////////////////////////  HANDLER VALIDATION MASS ACTIONS ///////////////
	const handleAllocateItems = (massDatas) => {
		const caseList = map(massDatas, (e) => e.id)
		const requestId = match.params.id
		const idDistributor = map(itemDistributorId, (e) => e.id)[0]
		const arg = `&itemDistributorId=${idDistributor}`
		const query = 'ToAllocateItems'
		const toast = 'toast__initKiosk__kioskCreation_growth__assignedProduct'

		let isAllocated = false
		let isDisabled = false
		let isHomeLocker = false

		forEach(massDatas, (elem) => {
			if (elem.isAllocated && !isAllocated) {
				isAllocated = true
			}
			if (elem.isDisabled && !isDisabled) {
				isDisabled = true
			}
			if (elem.isHomeLocker && !isHomeLocker) {
				isHomeLocker = true
			}
		})

		if (!isAllocated && !isDisabled && !isHomeLocker) {
			actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query, arg)
			handleCloseModal()
		} else if (isDisabled || isHomeLocker) {
			setShowModalAllocatedLockerImpossible(true)
		} else if (isAllocated) {
			handleCloseModal()
			setShowModalActivationsEdit(true)
		}
	}

	const handleAssignationImpossible = (_massDatas) => {
		handleCloseModal()
	}

	const handleAssignationsEdit = (massDatas) => {
		const caseList = map(massDatas, (e) => e.id)
		const requestId = match.params.id
		const idDistributor = map(itemDistributorId, (e) => e.id)[0]
		const arg = `&itemDistributorId=${idDistributor}`
		const query = massActionsSelected
		const toast = 'toast__initKiosk__kioskCreation_growth__assignedProduct'
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query, arg)
		handleCloseModal()
	}

	const handleUnlocateLockers = (massDatas) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__itemsUnllocate'
		const caseList = map(massDatas, (e) => e.id)
		const query = massActionsSelected
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}

	const handleDeleteHomeLockers = (massDatas) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__homeLockersDeleted'
		const caseList = map(massDatas, (e) => e.id)
		const query = massActionsSelected
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}

	const handleActivateLockers = (massDatas) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__lockersActivated'
		const caseList = map(massDatas, (e) => e.id)
		const query = 'ToActivateLockers'
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}

	const handleDesactivateLockers = (massDatas) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__lockersDeactivated'
		const caseList = map(massDatas, (e) => e.id)
		const query = massActionsSelected
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}
	const handleDesactivateAllocateLockers = (massDatas) => {
		const toast = 'toast__initKiosk__kioskCreation_growth__lockersDeactivated'
		const caseList = map(massDatas, (e) => e.id)
		const query = massActionsSelected
		const requestId = match.params.id
		actionsImplantation.putUnitActionWithId(toast, caseList, requestId, query)
		handleCloseModal()
	}
	///////////////////////////  REST HANDLER/////////////////////////////
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}
	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleRedirect = () => {
		!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[32])) &&
			history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)

		!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[33])) &&
			history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)
	}

	const handlePagingDistribution = (paging) => {
		setPaging(paging)
		actionsImplantation.postKioskImplantation(handleFilterSend(), match.params.id, paging)
	}

	const handleFollowingStep = () => {
		const pathName = location.pathname
		actionsImplantation.putValidateImplantation(match.params.id, pathName.indexOf(uriList.initKioskCustomerManager) === -1 ? '' : 'customer')
	}

	useEffect(() => {
		if (idDisplayStandImplantationNextStepError === 1) {
			setValidationImpossible(true)
		}
		if (idDisplayStandImplantationNextStepError === 2) {
			setValidationImpossible(true)
		}
	}, [idDisplayStandImplantationNextStepError])

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)

		if (isUndefined(pg)) {
			pg = { page: '0', size: '50' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)
		actionsImplantation.postKioskImplantation(handleFilterSend(), match.params.id, pg)
	}
	const handleFilterSend = () => {
		let filtersCp = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}
		let filtersSelection = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersCp }

		if (initKioskCreationIsUpdate) {
			filtersSelection = {
				lockerSizes: {
					updated: true,
				},
			}
			filtersOut = { ...filtersSelection, ...filtersCp }
			/* 	filtersCp.filtersSelection.lockerSizes = {
					...filtersCp.filtersSelection.lockerSizes,
					updated: true,
				} */
		}
		return {
			...filtersOut,
			withFilters: true,
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		if (!isUndefined(initKioskCreationStatus)) {
			setColumns([
				{
					columnReferential: 'kioskInCreationImplantation_displayStandLabel',
					dataHook: 'displayStandLabel',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_displayStandLabel'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_lockerLabel',
					dataHook: 'lockerLabel',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerLabel'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_lockerFormat',
					dataHook: 'lockerFormat',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerFormat'],
					sortable: true,
					isAuthorize: true,
					toTranslate: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_lockerState',
					dataHook: 'lockerState',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerState'],
					sortable: true,
					isAuthorize: true,
					component: KioskImplantationStatus,
				},
				{
					columnReferential: 'kioskInCreationImplantation_homeLocker',
					dataHook: 'lockerReceptionDesk',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerIsHome'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_itemImage',
					dataHook: 'itemPicture',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemPicture'],
					sortable: true,
					isAuthorize: true,
					component: KioskImplantationImg,
				},
				{
					columnReferential: 'kioskInCreationImplantation_itemCode',
					dataHook: 'codeItem',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemCode'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_itemName',
					dataHook: 'itemLabelToDisplay',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemLabelToDisplay'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_brand',

					dataHook: 'itemBrand.label',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemBrand'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_type',
					dataHook: 'gasType',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemType'],
					sortable: true,
					isAuthorize: true,
				},
				{
					columnReferential: 'kioskInCreationImplantation_family',
					dataHook: 'itemFamily.translationKey',
					headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemFamilly'],
					sortable: true,
					isAuthorize: true,
					toTranslate: true,
				},
				{
					action: true,
					isFixed: true,
					tooltipPart: 'implantation',
					component: ActionsTable,
					withIcons: false,
					rest: {
						paperActionsList: [
							{
								name: translations['tooltip_admin_initKiosk_step_growth_toAllocateItem'],
								translationKey: 'tooltip_admin_initKiosk_step_growth_toAllocateItem',
								clickAction: (row) => {
									handleItemAssign(row)
								},
								isVisible: (row) =>
									(!row.isDisabled || !row.isHomeLocker) &&
									filter(
										row.actions,
										(e) => e.translationKey === 'page__initKiosk__kioskCreation_growth_actions_toAllocateIem'
									)[0] &&
									initKioskCreationStatus?.editable,
								//iconDef: alocateItem,
							},
							{
								name: translations['page__initKiosk__kioskCreation_growth_actions_toUnllocateItem'],
								translationKey: 'tooltip_admin_initKiosk_step_growth_toUnllocateItem',
								clickAction: (row) => {
									handleUnlocateItem(row)
								},
								isVisible: (row) =>
									row.isAllocated &&
									filter(
										row.actions,
										(e) => e.translationKey === 'page__initKiosk__kioskCreation_growth_actions_toUnllocateItem'
									)[0] &&
									initKioskCreationStatus?.editable,
								//iconDef: unlocateItem,
							},
							{
								name: translations['page__initKiosk__kioskCreation_growth_actions_toSetHomeLocker'],
								translationKey: 'tooltip_admin_initKiosk_step_growth_toSetHomeLocker',
								clickAction: (row) => {
									handleDeclareHomeLocker(row)
								},
								isVisible: (row) =>
									(!row.isAllocated ||
										!row.isDisabled ||
										!row.isHomeLocker ||
										idDisplayStandImplantation === 4 ||
										row.lockerFormat === translations['ref__lockerSize__accessory']) &&
									filter(
										row.actions,
										(e) => e.translationKey === 'page__initKiosk__kioskCreation_growth_actions_toSetHomeLocker'
									)[0] &&
									initKioskCreationStatus?.editable,
								//icon: declareHomeLocker,
							},
							{
								name: translations['page__initKiosk__kioskCreation_growth_actions_toDeleteHomeLocker'],
								translationKey: 'tooltip_admin_initKiosk_step_growth_toDeleteHomeLocker',
								clickAction: (row) => {
									handleSetDeleteHomeLocker(row)
								},
								isVisible: (row) =>
									row.isHomeLocker &&
									filter(
										row.actions,
										(e) => e.translationKey === 'page__initKiosk__kioskCreation_growth_actions_toDeleteHomeLocker'
									)[0] &&
									initKioskCreationStatus?.editable,
								//icon: deleteHomeLocker,
							},
							{
								name: translations['page__initKiosk__kioskCreation_growth_actions_toActivateLocker'],
								translationKey: 'tooltip_admin_initKiosk_step_growth_toEnableLocker',
								clickAction: (row) => {
									handleActivateLocker(row)
								},
								isVisible: (row) =>
									row.isDisabled &&
									filter(
										row.actions,
										(e) => e.translationKey === 'page__initKiosk__kioskCreation_growth_actions_toActivateLocker'
									)[0] &&
									initKioskCreationStatus?.editable,
								//icon: alocateLocker,
							},
							{
								name: translations['page__initKiosk__kioskCreation_growth_actions_toDeactivateLocker'],
								translationKey: 'tooltip_admin_initKiosk_step_growth_toDisableLocker',
								clickAction: (row) => {
									handleSetDesactivateLocker(row)
								},
								isVisible: (row) =>
									!row.isDisabled &&
									filter(
										row.actions,
										(e) => e.translationKey === 'page__initKiosk__kioskCreation_growth_actions_toDeactivateLocker'
									)[0] &&
									initKioskCreationStatus?.editable,
								//icon: unlocateLocker,
							},
						],
					},
				},
			])
		}
	}, [translations, initKioskCreationStatus])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 27,
		labelPageTable: 'kioskInCreationImplantation',
	}

	const [configTableTitle, setConfigTableTitle] = useState({ actions: {}, paging: { fnSendTo: (paging) => handlePagingDistribution(paging) } })
	const [configTable, setConfigTable] = useState({ actions: {} })

	/////////////////////////////// MODAL CONFIG /////////////////////////////////
	// MODAL ACTION UNITAIRE
	const actionModalCfg = [
		{
			// Assignation
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toAllocateLockers'],
			showModal: showModalActivation,
			closeModal: handleCloseModal,
			icon: true,
			width: 555,
			filters: true,
			modalText: [
				{
					label: `${translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_filterByBrand']} :`,
					list: initKioskCreationItemsBrands,
					actionHandler: handleFilterBrands,
					width: 150,
					placeHolder: translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_filterByBrand_placeholder'],
				},
				{
					label: `${translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_selectItem']} :`,
					list: !isUndefined(catalogItems) ? catalogItems : initKioskCreationItemsCatalog,
					width: 150,
					actionHandler: handleGetItemDistributorId,
					placeHolder: translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_selectItem_placeholder'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleAllocateItem(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
					disabled: !itemDistributorId || itemDistributorId.length === 0,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Assignation Edit
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__changeAllocate'],
			showModal: showModalActivationEdit,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			filters: false,
			modalText: [
				{
					text: 'modal__initKiosk__kioskCreation_growth__body__changeAllocates',
					formatter: true, // Indicates that StringFormatter will be called
					hasColonCharacter: true, // Indicates the presence of ":" (colon) character
					param: [currentBrandEdit, currentItemEdit],
				},
				{
					text: currentItemBrand === ' ' ? `${currentCaseId} : ${currentItem}` : `${currentCaseId} : ${currentItemBrand} - ${currentItem}`,
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__changeAllocate_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleAssignationEdit(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			//  Unlocate Locker
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toUnllocateLockers'],
			showModal: showModalUnlocateLocker,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			filters: false,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__title__toUnllocateItem']} :`,
				},
				{
					text:
						isUndefined(currentItemBrand) || isNull(currentItemBrand)
							? `${currentCaseId} : ${currentItem}`
							: `${currentCaseId} : ${currentItemBrand}  ${currentItem}`,
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toUnllocateItem_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleUnlocateLocker(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Declare Home Locker Brand
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toSetHomeLocker_item'],
			showModal: showModalDeclareHomeLockerBrand,
			closeModal: handleCloseModal,
			icon: true,
			width: 555,
			filters: true,
			modalText: [
				{
					text: 'modal__initKiosk__kioskCreation_growth__body__toSetHomeLocker',
					param: [currentCaseId],
					formatter: true, // Indicates that StringFormatter will be called
					hasColonCharacter: true, // Indicates the presence of ":" (colon) character
					width: 440,
					actionHandler: handleGetItemBrandId,
					list: initKioskCreationItemsBrands,
					direction: 'column',
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDeclareHomeLockerBrand(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
					disabled: !itemBrandId || itemBrandId.length === 0,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Declare Home Locker Item
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toSetHomeLocker_item'],
			showModal: showModalDeclareHomeLockerItem,
			closeModal: handleCloseModal,
			icon: true,
			width: 555,
			filters: true,
			modalText: [
				{
					text: 'modal__initKiosk__kioskCreation_growth__body__toSetHomeLocker_item',
					width: 440,
					param: [currentCaseId],
					formatter: true, // Indicates that StringFormatter will be called
					hasColonCharacter: true, // Indicates the presence of ":" (colon) character
					list: initKioskCreationItemsCatalog,
					actionHandler: handleGetItemDistributorId,
					direction: 'column',
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDeclareHomeLockerItem(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
					disabled: !itemDistributorId || itemDistributorId.length === 0,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Delete Home Locker
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toDeleteHomeLocker'],
			showModal: showModalDeleteHomeLocker,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toDeleteHomeLocker']} :`,
				},
				{
					text: `${currentCaseId}`,
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toDeleteHomeLocker_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDeleteHomeLocker(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Desactivate Locker
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toDeactivateLocker'],
			showModal: showModalDesactivateLocker,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toDeactivateLocker']} :`,
				},
				{
					text: `${currentCaseId}`,
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toDeactivateLocker_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDesactivateLocker(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Desactivate Allocated Locker
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toDeactivateAllocateLocker'],
			showModal: showModalDesactivateAllocatedLocker,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toDeactivateAllocateLocker']} :`,
				},
				{
					text:
						isUndefined(currentItemBrand) || isNull(currentItemBrand)
							? `${currentCaseId} : ${currentItem}`
							: `${currentCaseId} : ${currentItemBrand}  ${currentItem}`,
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toDeactivateAllocateLocker_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDesactivateLocker(row),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},

		//----------------------------------ACTIONS MASSES----------------------------------------------------//
		{
			// Assignations
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toAllocateLockers'],
			showModal: showModalActions,
			closeModal: handleCloseModal,
			icon: true,
			width: 555,
			filters: true,
			modalText: [
				{
					label: translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_filterByBrand'],
					list: initKioskCreationItemsBrands,
					actionHandler: handleFilterBrands,
					width: 150,
					placeHolder: translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_filterByBrand_placeholder'],
				},
				{
					label: translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_selectItem'],
					list: !isUndefined(catalogItems) ? catalogItems : initKioskCreationItemsCatalog,
					width: 150,
					actionHandler: handleGetItemDistributorId,
					placeHolder: translations['modal__initKiosk__kioskCreation_growth__body__toAllocateLockers_selectItem_placeholder'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleAllocateItems(massDatas),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
					disabled: !itemDistributorId || itemDistributorId.length === 0,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Allocated Locker Impossible
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__cannotAllocateLockers'],
			showModal: showModalAllocatedLockerImpossible,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__cannotAllocateDeactivateLockers']} :`,
				},
				{
					arrayText: map(massDatas, (elem) => (elem.isDisabled ? elem.lockerLabel : null)),
					color: theme.colors.primary,
				},
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__cannotAllocateHomeLockers']} :`,
				},
				{
					arrayText: map(massDatas, (elem) => elem.isHomeLocker && elem.lockerLabel),
					color: theme.colors.primary,
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleAssignationImpossible(massDatas),
					text: translations['common__text__ok'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
					displayNone: true,
				},
			},
		},
		{
			// Assignations Edit
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__changeAllocates'],
			showModal: showModalActivationsEdit,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: 'modal__initKiosk__kioskCreation_growth__body__changeAllocates',
					param: [currentBrandEdit, currentItemEdit],
					formatter: true, // Indicates that StringFormatter will be called
					hasColonCharacter: true, // Indicates the presence of ":" (colon) character
				},
				{
					arrayText: map(massDatas, (elem) => elem.isAllocated && elem.lockerLabel),
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__changeAllocates_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleAssignationsEdit(massDatas),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Unlocate Lockers
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toUnllocateLockers'],
			showModal: showModalUnlocateLockers,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toUnllocateLockers']} :`,
				},
				{
					arrayText: map(
						massDatas,
						(elem) =>
							elem.isAllocated &&
							`${elem.lockerLabel} : ${!isUndefined(elem?.itemBrand?.label) ? elem?.itemBrand?.label : ''} - ${elem.itemLabelToDisplay}`
					),
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toUnllocateLockers_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleUnlocateLockers(massDatas),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Delete Home Lockers
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toDeleteHomeLockers'],
			showModal: showModalDeleteHomeLockers,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toDeleteHomeLockers']} :`,
				},
				{
					arrayText: map(massDatas, (elem) => elem.isHomeLocker && elem.lockerLabel),
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toDeleteHomeLockers_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDeleteHomeLockers(massDatas),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Desactivate Lockers
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toDisableLockers'],
			showModal: showModalDesactivateLockers,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toDisableLockers']} :`,
				},
				{
					arrayText: map(massDatas, (elem) => elem.lockerLabel),
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toDisableLockers_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDesactivateLockers(massDatas),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Desactivate Allocated Lockers
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__toDisableAllocateLockers'],
			showModal: showModalDesactivateAllocatedLockers,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text: `${translations['modal__initKiosk__kioskCreation_growth__body__toDisableAllocateLockers']}`,
				},
				{
					arrayText: map(
						massDatas,
						(elem) =>
							elem.isHomeLocker &&
							elem.isAllocated &&
							`${elem.lockerLabel} : ${isNull(elem.itemBrand.label) ? '' : elem.itemBrand.label} ${elem.itemLabelToDisplay}`
					),
					color: theme.colors.primary,
				},
				{
					text: translations['modal__initKiosk__kioskCreation_growth__body__toDisableAllocateLockers_confirm'],
				},
			],
			modalButton: {
				validation: {
					actionHandler: () => handleDesactivateAllocateLockers(massDatas),
					text: translations['common__text__validate'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
				},
			},
		},
		{
			// Validation Impossible
			headerTitle: translations['modal__initKiosk__kioskCreation_growth__title__validationFail'],
			showModal: validationImpossible,
			closeModal: handleCloseModal,
			icon: true,
			color: 'error',
			width: 555,
			modalText: [
				{
					text:
						idDisplayStandImplantationNextStepError === 2
							? 'modal__initKiosk__kioskCreation_growth__body__validationFail_notAllocatedItems'
							: 'modal__initKiosk__kioskCreation_growth__body__validationFail',
					param: [translations[idDisplayStandImplantationNextStepErrorMessage]],
					replace: true,
				},
			],
			modalButton: {
				validation: {
					actionHandler: handleCloseModal,
					text: translations['common__text__ok'],
					bgColor: theme.colors.validation,
					imgValidation: Validation,
				},
				cancel: {
					actionHandler: handleCloseModal,
					text: translations['common__text__cancel'],
					bgColor: theme.colors.error,
					imgCancel: Cancel,
					displayNone: true,
				},
			},
		},
	]

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(initKioskCreationItems) && !isUndefined(initKioskCreationItems)) {
			cfg.paging = {
				totalElements: initKioskCreationItems.data?.headerContent?.contentPagined?.totalElements,
				totalPages: initKioskCreationItems.data?.headerContent?.contentPagined?.totalPages,
				fnSendTo: (paging) => handlePagingDistribution(paging),
			}
		}
		setConfigTableTitle(cfg)
	}, [initKioskCreationItems])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters?.searchField !== searchValue || searchValue === initKioskCreation) return
		handleSubmit()
	}, [filters?.searchField])

	useEffect(() => {
		const filtersCp = cloneDeep(initKioskCreationFilters)

		if (!isUndefined(filtersCp)) {
			filtersCp.withFilters = true
		}
		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [initKioskCreationFilters])

	useEffect(() => {
		// Disable fields if we are coming from "View" action, or by charging request with URL address
		let editable = true
		if (initKioskCreation.forceReadOnly) {
			editable = false
		} else {
			editable = initKioskCreationStatus?.editable
		}
		setIsEditable(editable)
	}, [initKioskCreationStatus])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = [
			<TooltipHelp content={'tooltipHelp__admin__modal__body__growth'} childrenPos={1}>
				{translations['page__initKiosk__kioskCreation_growth_title']}
			</TooltipHelp>,
		]

		cfg.paging = {
			totalElements: initKioskCreationItems.data?.headerContent?.contentPagined?.totalElements,
			totalPages: initKioskCreationItems.data?.headerContent?.contentPagined?.totalPages,
			fnSendTo: (paging) => handlePagingDistribution(paging),
		}

		cfg.actions = {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
			followingStep: {
				id: 'continue',
				type: 'submit',
				imgLeftMgin: '11px',
				imgMgin: '11px',
				img: ArrowWhiteRight,
				bgColor: theme.colors.validation,
				height: 32,
				width: 208,
				text: translations['page__initKiosk__common__action_nextStep'],
				actionHandler: handleFollowingStep,
				step: initKioskCreationStatus?.statusId >= 8 ? true : false,
				disabled: !isEditable,
			},

			actionsList: {
				list: idDisplayStandImplantationMassActions,
				zeroValue: 'Actions', //translations['common__text__actions'],
				onChangeHandler: handleSwitchActions,
				step: true,
				width: '218',
			},
			edit: {
				getDataSelected: (data, scope, query) => {
					handleGetSelectedRow(data, query)
				},
			},
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_growth_filters_lockerState']}
					data={filters?.filtersSelection?.lockerStates?.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'lockerStates'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_growth_filters_lockerFormat']}
					data={filters?.filtersSelection?.lockerSizes?.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'lockerSizes'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_growth_filters_lockerLabel']}
					data={filters?.filtersSelection?.displayStands?.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'displayStands'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_growth_filters_item']}
					data={filters?.filtersSelection?.items?.filterElements || []}
					translations={translations}
					//toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'items'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_growth_filters_familly']}
					data={filters?.filtersSelection?.famillies?.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					toTranslate={true}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'famillies'}
				/>
			),
		]

		cfg.usingRafters = true
		cfg.customHeightFilters = 50

		setConfigTableTitle(cfg)
	}, [translations, filters, isEditable, initKioskCreationStatus])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.actions = {
			edit: {
				getDataSelected: (data, scope, query) => {
					handleGetSelectedRow(data, query)
				},
			},
		}
		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return

		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				searchField: '',
			}

			actionsImplantation.postKioskImplantation(filtersCp, match.params.id)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [translations])

	useEffect(() => {
		return function cleanUp() {
			actionsImplantation.resetDataImplantation()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	// test if we have a success when we set a action, if it ok we pass a booleen to true
	useEffect(() => {
		if (initKioskCreationIsUpdate) {
			actionsImplantation.postKioskImplantation({ searchField: '', withFilters: false }, match.params.id, paging)
		}
	}, [initKioskCreationIsUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////
	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={initKioskCreationContent}
				inputConfig={configTable}
				currentPaging={paging}
				tableReferential={tableReferential}
			/>
		)
	}, [initKioskCreationContent, columns, configTable, translations, paging])
	return (
		<>
			{/* MODAL ACTION UNITAIRE */}
			{map(
				actionModalCfg,
				(elem) =>
					elem.showModal && (
						<Modals
							showModal={elem.showModal}
							closeModalHandler={elem.closeModal}
							level={elem.color}
							icon={true}
							title={elem.headerTitle}
							maxWidth={elem.width}
						>
							{elem.filters ? (
								map(elem.modalText, (e) => (
									<>
										{e.formatter && (
											<TextModal
												dangerouslySetInnerHTML={{
													__html:
														StringFormatter.ResponseMessageParser(
															translations[e.text],
															map(e.param, (e) => `<span style="color:${theme.colors.primary}">${e} </span>`)
														) + `${e.hasColonCharacter ? ' :' : ''}`,
												}}
											/>
										)}

										<ModalSelectWrapper direction={e.direction}>
											<LabelTextCustom>{e.label}</LabelTextCustom>
											<SelectInputWrapper blueColor={true}>
												<SelectInput name="test" onChange={e.actionHandler}>
													<option value="0">{e.placeHolder}</option>
													{map(e.list, (e) => (
														<option key={e.id} value={parseInt(e.id)}>
															{e.label}
														</option>
													))}
												</SelectInput>
											</SelectInputWrapper>
										</ModalSelectWrapper>
									</>
								))
							) : (
								<TextModalWrapperBottom>
									{map(elem.modalText, (e) =>
										e.formatter ? (
											<TextModal
												dangerouslySetInnerHTML={{
													__html:
														StringFormatter.ResponseMessageParser(
															translations[e.text],
															map(
																e.param,
																(p) =>
																	`<span style="color:${theme.colors.primary}">${!isUndefined(p) ? p : ''} </span>`
															)
														) + `${e.hasColonCharacter ? ' :' : ''}`,
												}}
											/>
										) : e.replace ? (
											<TextModal
												dangerouslySetInnerHTML={{
													__html: StringFormatter.ResponseMessageParser(
														translations[e.text].split('/n').join('<br><br>'),
														map(e.param, (p) => `<span style="color:${theme.colors.primary}">${p} </span>`)
													),
												}}
											></TextModal>
										) : e.arrayText ? (
											<WrapperElements>
												{map(
													e.arrayText,
													(p, k) =>
														p !== false &&
														!isNull(p) && (
															<Elements color={e.color} padding={10}>
																{p}
															</Elements>
														)
												)}
											</WrapperElements>
										) : (
											<TextModal color={e.color} padding={10}>
												{e.text}
											</TextModal>
										)
									)}
								</TextModalWrapperBottom>
							)}
							<ButtonWrapper>
								<Button
									actionHandler={elem?.modalButton?.cancel?.actionHandler}
									text={elem?.modalButton?.cancel?.text}
									bgColor={elem?.modalButton?.cancel?.bgColor}
									//margin='true'
									img={elem.modalButton?.cancel?.imgCancel}
									displayNone={elem?.modalButton?.cancel?.displayNone}
								/>
								<Button
									actionHandler={elem?.modalButton?.validation?.actionHandler}
									text={elem?.modalButton?.validation?.text}
									bgColor={elem?.modalButton?.validation?.bgColor}
									img={elem?.modalButton?.validation?.imgValidation}
									disabled={elem?.modalButton?.validation?.disabled}
								/>
							</ButtonWrapper>
						</Modals>
					)
			)}

			{/* TABLEAU */}

			<KioskAddItemWrapper>
				<PageWrapperLinksCustom rafterDisplayed={initKioskCreation.statusId >= 6 ? true : false}>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinksCustom>

				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} isFollowingStep={true} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</KioskAddItemWrapper>
		</>
	)
}

KioskImplantation.propTypes = {}

KioskImplantation.defaultPropTypes = {}

export default KioskImplantation
